import * as v from 'valibot';

export const portalAccessSchema = v.optional(v.object({
  isBillingAvailable: v.optional(v.boolean()),
  isBoAvailable: v.optional(v.boolean()),
  isCpAvailable: v.optional(v.boolean()),
  isMultiCpAdmin: v.optional(v.boolean()),
  isTpAvailable: v.optional(v.boolean()),
  isCatalogBuilderAvailable: v.optional(v.boolean()),
  cpCount: v.optional(v.number()),
}));